import React from 'react';
import styled from 'styled-components';
import logo from '../assets/NEC_logo-icon.png';

function Navbar(props) {
    return (
        <>
            <NavbarContainer>
                <HeaderFirstLine />
                <HeaderLogoTopBorder />
                {props.Childrens}
            </NavbarContainer>
            <Footer />
        </>
    );
}

const NavbarContainer = styled.div`
    background-image: repeating-linear-gradient(45deg, #0072bc 0%, rgba(3, 78, 162, 0.5) 1%, #0072bc 2%);
    box-shadow: inset 0px -40px 50px 40px rgba(0, 79, 185, 0.6);
`;

const Footer = styled.div`
    background-image: repeating-linear-gradient(45deg, #0072bc 0%, rgba(3, 78, 162, 0.5) 1%, #0072bc 2%);
    box-shadow: inset 0px -40px 50px 40px rgba(0, 79, 185, 0.6);
    height: 30px;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
`;

const HeaderFirstLine = styled.div`
        height: 30px;
        display: flex;
`;

const HeaderLogoTopBorder = styled.div`
    background-image: linear-gradient(90deg, #ffffff 0%, #666666 20%, #ffffff 50%, #666666 80%, #ffffff 100%);
    height: 1px;
    display: flex;
`;

export default Navbar;